import {
  configureStore,
  combineReducers,
  getDefaultMiddleware,
} from '@reduxjs/toolkit';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import ticketListReducer from '../components/HomePage/TicketList/TicketListSlice';
import contentTabReducer from '../components/HomePage/ContentTabs/ContentTabsSlice';
import editTicketReducer from '../components/EditTicket/EditTicketSlice';
import wagonResearchReducer from '../components/WagonDetailsPage/WagonDetailsPageSlice';
import homeReducer from '../components/HomePage/HomeSlice';
import workshopTimeReducer from '../components/WorkshopTimePage/WorkshopTimeSlice';

const persistConfig = {
  key: 'reduxStates',
  storage,
};

const reducers = combineReducers({
  ticketList: ticketListReducer,
  contentTab: contentTabReducer,
  editTicket: editTicketReducer,
  wagonResearch: wagonResearchReducer,
  home: homeReducer,
  workshopTime: workshopTimeReducer,
});

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore(
  {
    reducer: persistedReducer,
    middleware: getDefaultMiddleware({
      serializableCheck: false,
    }),
  },
  composeWithDevTools(),
);
